export const dashboardTabs = [
  {
    id: 'orders',
    name: 'Orders',
    component: 'myNewSelfSection',
    isDefault: true,
    condition: null // Always visible
  },
  {
    id: 'doctor-chat',
    name: 'Doctor Chat',
    component: 'talkToDocWindow',
    condition: (user) => user.health_id !== null
  },
  {
    id: 'dosage',
    name: 'Dosage',
    component: 'prescriptionShow',
    condition: (user, computed) => computed.hasPrescription
  },
  {
    id: 'profile',
    name: 'Profile',
    component: 'profileSection',
    condition: null // Always visible
  },
  {
    id: 'billing',
    name: 'Billing',
    component: 'orderInfoSection',
    condition: null // Always visible
  },
  {
    id: 'upgrade-tir',
    name: 'Upgrade',
    component: 'buyMoreTir',
    condition: (user, computed) => computed.hasPrescription && computed.noTirRefill
  },
  {
    id: 'upgrade-sema',
    name: 'Upgrade',
    component: 'upgradeSema',
    condition: (user, computed) => computed.hasSemaglutide
  }
];

export const getVisibleTabs = (user, computedProps) => {
  return dashboardTabs.filter(tab => {
    if (!tab.condition) return true;
    return tab.condition(user, computedProps);
  });
};

export const getDefaultTab = (visibleTabs) => {
  const defaultTab = visibleTabs.find(tab => tab.isDefault);
  return defaultTab ? defaultTab.id : visibleTabs[0]?.id || 'orders';
};